import React from "react";
import { Container } from "../Home/styleHome";
import {
  ContainerContato,
  ContainerInfo,
  ContainerMap,
  LinkContato,
  WrapperLogo
} from "./styleContato";
import { Link } from "react-scroll";
import {
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  Map,
  MapPin,
  Phone,
  Youtube
} from "react-feather";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import logo from "../imagens/logo@2x.png";
import whatsapp from "../imagens/whatsapp@2x.png";
import enviar from "../imagens/enviar.php";
import ContactForm from "./ContactForm";

export const Contato = () => {
  return (
    <Container id={"contato"}>
      <ContainerContato id={"contato"}>
        <ContainerMap>
          <ContactForm />
          {/*<div>*/}
          {/*    <img src={mapa}/>*/}
          {/*</div>*/}

          <div style={{ width: "50%", textAlign: "center" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d906.6347787240228!2d-48.62033202625551!3d-27.585750696659744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95274977a9f73b15%3A0x2f3aa5bdbfb1312f!2sWAVECODE%20%7C%20Tecnologia%20em%20Preg%C3%B5es%20Eletr%C3%B4nicos!5e0!3m2!1spt-BR!2sbr!4v1583444674765!5m2!1spt-BR!2sbr"
              width="600"
              height="450"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen=""
            ></iframe>
          </div>
        </ContainerMap>
        <ContainerInfo>
          <WrapperLogo>
            <img src={logo} width={"200px"} height={"35px"} />

            <div style={{ marginLeft: "30px" }}>
              <LinkContato>
                <Link
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  Início
                </Link>
              </LinkContato>

              <LinkContato>
                <Link
                  to="empresa"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  Plataforma
                </Link>
              </LinkContato>

              <LinkContato>
                <Link
                  to="editais"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  Editais
                </Link>
              </LinkContato>
            </div>
            <div style={{ marginLeft: "30px" }}>
              <LinkContato>
                <Link
                  to="monitoramento"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  Monitoramento
                </Link>
              </LinkContato>
              <LinkContato>
                <Link
                  to="disputa"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  Disputa
                </Link>
              </LinkContato>

              <LinkContato>
                <Link
                  to="disputa"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                  Teste Grátis
                </Link>
              </LinkContato>
            </div>
          </WrapperLogo>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyItems: "center",
              fontSize: "40px",
              color: "white"
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Phone size={"30px"} />
              <span style={{ marginLeft: "10px", fontSize: "35px" }}>
                <b>48 3375-2379</b>
              </span>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "15%",
              color: "#cecece"
            }}
          >
            <div style={{ display: "flex" }}>
              <Mail />
              <span style={{ marginLeft: "10px" }}>
                contato@wavecode.com.br
              </span>
            </div>
            <div style={{ display: "flex" }}>
              <MapPin size={"60px"} />
              <span style={{ marginLeft: "10px" }}>
                Rua João Grumiche, 2217 - Sl.501 - CEP: 88108-167 São José,
                Santa Catarina.{" "}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                color: "rgba(255,255,255,0.78)"
              }}
            >
              <Instagram
                onClick={() =>
                  window.open("https://instagram.com/wavecodeoficial", "_blank")
                }
              />
              <Linkedin
                onClick={() =>
                  window.open(
                    "https://br.linkedin.com/company/wavecode-desenvolvimento-de-softwares",
                    "_blank"
                  )
                }
              />
              <Youtube
                onClick={() =>
                  window.open(
                    "https://www.youtube.com/channel/UCOxqBMtrdt8NwJgBXxbCaig",
                    "_blank"
                  )
                }
              />
              <Facebook
                onClick={() =>
                  window.open(
                    "https://www.facebook.com/lancesautomaticos/",
                    "_blank"
                  )
                }
              />
            </div>
          </div>
        </ContainerInfo>
      </ContainerContato>
    </Container>
  );
};
